const popConfig = {
  endpoint: "https://www.eventpop.me/e/microsite/8764.json",
  totalOrderMinimum: 500.00
}

export default popConfig;